const importeConCentavos = (monto: number): boolean =>
  Number.isFinite(monto) && Math.round(monto * 100) / 100 === monto;

export const validarImporteCostoActividad = (monto: number, esDonacion: boolean): string | null => {
  if (!importeConCentavos(monto) || monto < 0 || (monto === 0 && !esDonacion)) {
    return 'El gasto debe tener un importe finito con hasta dos decimales; solo una donación admite cero.';
  }
  return null;
};

export const validarImportesVentaActividad = (
  total: number, pagado: number, cantidad: number, entregada: number,
): string | null => {
  if (!importeConCentavos(total) || total <= 0) {
    return 'El total de la venta debe ser positivo, finito y tener hasta dos decimales.';
  }
  if (!importeConCentavos(pagado) || pagado < 0) {
    return 'El monto pagado de la venta es inconsistente: requiere revisión contable.';
  }
  if (total < pagado) return 'El total de la venta no puede ser menor al monto ya pagado.';
  if (!Number.isSafeInteger(cantidad) || cantidad <= 0 || !Number.isSafeInteger(entregada)
    || entregada < 0 || entregada > cantidad) {
    return 'La cantidad debe ser positiva y no puede ser menor a lo ya entregado.';
  }
  return null;
};
